export enum EPartnersPerm {
    PARTNERS_VIEW = 'partners_view',
    PARTNERS_DELETE = 'partners_delete',
    PARTNERS_EDIT = 'partners_edit'
}
